'use strict';

module.exports = require('./_formatLimit')('Minimum');



//////////////////
// WEBPACK FOOTER
// /Users/dnlytras/.npm/_npx/11246/lib/node_modules/landr/theme/node_modules/rendition/node_modules/ajv-keywords/keywords/formatMinimum.js
// module id = 689
// module chunks = 2